<template>
  <v-card-text>

    <v-form ref="accountBasicform">

      <v-text-field v-model="account.name" outlined label="Company/Business Name" :rules="requiredRules" />

      <v-autocomplete v-model="account.timezone" outlined label="Default Time Zone" :items="availableTimeZones" />

      <v-btn rounded block x-large color="primary" @click="updateAccount()">
        Save & Continue
      </v-btn>

    </v-form>

  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment-timezone';

export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      availableTimeZones: moment.tz.names()
    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading"])
  },
  // watch: {
  //   'isSavingAccount': function (value) {
  //     if (value) {
  //       this.updateAccount();
  //     }
  //   }
  // },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    updateAccount() {
      if (!this.$refs.accountBasicform.validate()) {
        this.addErrorMessage("Please check all required fields are entered");
        return;
      }
      const data = Object.assign({}, this.account);
      data.logo = null;
      data.admins = null;
      data.locations = null;
      data.accountTerminologies = null;
      data.admins = null;
      data.profileMappingSet = null;

      this.$axios
        .post("/account/info", data)
        .then(() => {
          console.log("updated account");
          this.addSuccessMessage("Account updated");
          this.$emit("continueNext");
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    }
  }
};
</script>
